import { render, staticRenderFns } from "./iFrameDoc.vue?vue&type=template&id=0ecea81c&scoped=true&"
import script from "./iFrameDoc.vue?vue&type=script&lang=js&"
export * from "./iFrameDoc.vue?vue&type=script&lang=js&"
import style0 from "./iFrameDoc.vue?vue&type=style&index=0&id=0ecea81c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecea81c",
  null
  
)

export default component.exports